import * as MeetingsActions from "./meetings.actions";

import {createReducer, on} from "@ngrx/store";
import {createEntityAdapter, EntityState} from "@ngrx/entity";
import {TenMeeting} from "../../_models/meetings.models";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const tenMeetingsFeatureKey = 'meetings';

export interface TenMeetingState extends EntityState<TenMeeting> {
    selectedMeeting: string,
    componentOpened: boolean,
    listLoading: DahLoadingType
}

export const adapter = createEntityAdapter<TenMeeting>({});

export const initialState: TenMeetingState = adapter.getInitialState({
    selectedMeeting: '',
    componentOpened: false,
    listLoading: 'listLoading' as DahLoadingType,
});

export const tenMeetingReducer = createReducer(
    initialState,

    on(MeetingsActions.loadList, (state) => ({
        ...state,
        listLoading: state.componentOpened ? undefined : 'listLoading' as DahLoadingType,
    })),

    on(MeetingsActions.loadListSuccess, (state, payload) => adapter.setAll(
        payload.items,
        {
            ...state,
            listLoading: undefined,
            componentOpened: true
        }
    )),

    on(MeetingsActions.loadListFailure, (state) => ({
        ...state,
        listLoading: undefined,
    })),

    on(MeetingsActions.loadItem, (state, payload: { itemId: string }) => ({
        ...state,
        listLoading: state.entities[payload.itemId]
            ? (state.entities[payload.itemId]?.agenda ? undefined : 'listLoadNext' as DahLoadingType)
            : 'listLoading' as DahLoadingType,
        selectedMeeting: payload.itemId
    })),

    on(MeetingsActions.loadItemSuccess, (state, payload) => adapter.upsertOne(
        payload.item,
        {
            ...state,
            listLoading: undefined
        })),

    on(MeetingsActions.loadItemFailure, (state) => ({
        ...state,
        listLoading: undefined,
    })),

    on(MeetingsActions.setMeetingId, (state, payload) => ({
        ...state,
        selectedMeeting: payload.itemId
    })),

    on(SetAllInitialStates, () => ({...initialState}))
);
